import { inject } from 'vue';
import { meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
var __default__ = {
  data: function data() {
    return {
      school: {}
    };
  },
  methods: {
    handleLogout: function handleLogout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'AppHeader',
  setup: function setup(__props) {
    var me = inject(meKey);
    return {
      __sfc: true,
      me: me
    };
  }
});